import React from 'react';
import { iconStyling } from './icons.ve.css';

export const ShopifyBuilderIcon: React.FC = () => (
    <svg className={iconStyling} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
            d="M21.25 7.5V4.5C21.25 4.08579 20.9142 3.75 20.5 3.75H3.5C3.08579 3.75 2.75 4.08579 2.75 4.5V18.5C2.75 18.9142 3.08579 19.25 3.5 19.25H7C7.41421 19.25 7.75 19.5858 7.75 20C7.75 20.4142 7.41421 20.75 7 20.75H3.5C2.25736 20.75 1.25 19.7426 1.25 18.5V4.5C1.25 3.25736 2.25736 2.25 3.5 2.25H20.5C21.7426 2.25 22.75 3.25736 22.75 4.5V7.5C22.75 7.91421 22.4142 8.25 22 8.25C21.5858 8.25 21.25 7.91421 21.25 7.5Z"
            fill="#222325"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.5 13C18.7092 13 18.8963 13.1303 18.9689 13.3265L19.411 14.5212C19.7655 15.4792 20.5208 16.2345 21.4788 16.589L22.6735 17.0311C22.8697 17.1037 23 17.2908 23 17.5C23 17.7092 22.8697 17.8963 22.6735 17.9689L21.4788 18.411C20.5208 18.7655 19.7655 19.5208 19.411 20.4788L18.9689 21.6735C18.8963 21.8697 18.7092 22 18.5 22C18.2908 22 18.1037 21.8697 18.0311 21.6735L17.589 20.4788C17.2345 19.5208 16.4792 18.7655 15.5212 18.411L14.3265 17.9689C14.1303 17.8963 14 17.7092 14 17.5C14 17.2908 14.1303 17.1037 14.3265 17.0311L15.5212 16.589C16.4792 16.2345 17.2345 15.4792 17.589 14.5212L18.0311 13.3265C18.1037 13.1303 18.2908 13 18.5 13Z"
            fill="#222325"
        />
        <path
            d="M18 6.5C18.4142 6.5 18.75 6.83579 18.75 7.25C18.75 7.66421 18.4142 8 18 8L6 8C5.58579 8 5.25 7.66421 5.25 7.25C5.25 6.83579 5.58579 6.5 6 6.5L18 6.5Z"
            fill="#222325"
        />
        <path
            d="M10 11L10.0771 11.0039C10.4551 11.0425 10.75 11.3618 10.75 11.75C10.75 12.1382 10.4551 12.4575 10.0771 12.4961L10 12.5L6 12.5C5.58579 12.5 5.25 12.1642 5.25 11.75C5.25 11.3358 5.58579 11 6 11L10 11Z"
            fill="#222325"
        />
    </svg>
);

ShopifyBuilderIcon.displayName = 'ShopifyBuilderIcon';
